export const STATUS_DRAFT = 1;
export const STATUS_PUBLISH = 2;
export const STATUS_PENDING = 3;

export default {
  STATUS_DRAFT,
  STATUS_PUBLISH,
  STATUS_PENDING
};
